import { Component, OnInit, Output, EventEmitter, Inject } from '@angular/core';
import { LOCAL_STORAGE, StorageService } from 'ngx-webstorage-service';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonSetting } from '../../common-class/survey';
import { ParticipationDataService } from '../../_services/participation-data.service';
import { SurveySpecificData } from '../../common-class/survey-specific-data';
import { ParticipationResponseData } from 'src/app/common-class/response-data';
import { OfflineSurvey } from '../../common-class/survey';
import { EncryptionAndDecryption } from 'src/app/COMMON-LOGIC/EncryptionAndDecryption';
declare var $: any;
@Component({
  selector: 'app-offline',
  templateUrl: './offline.component.html',
  styleUrls: ['./offline.component.css']
})
export class OfflineComponent implements OnInit {
  @Output() Startsurvey1 = new EventEmitter();
  @Output() SurveyResponseUpdate = new EventEmitter();
  @Output() GetData = new EventEmitter();
  public OfflineResponseData: any = [];
  public SurveyData: any = [];
  isPreview: boolean = false;
  selectedLang: number;
  urlParam: string;
  surveySpecificData: SurveySpecificData;
  ResponseCount: number;
  ResponseRecorded: number = 0;
  blnShowGotiT:boolean = true;
  isMobile:boolean= false;
  isTablet:boolean=false;
  isDeviceCSS:string="";
  UploadPerc:number;
  processCount: number = 1;
  prendingResponse:number=0;
  completeResponse:number=0;
  incompleteResponse:number=0;
  offlineID:number=0;
  isOfflineEnable: boolean=true;
  surveyTitle:string="";
  corp_mailid:string
  isSomthingWrong:boolean= false;
  isCancelUpload: boolean = false;

  constructor(@Inject(LOCAL_STORAGE) private storage: StorageService, private router: Router, private activatedRoute: ActivatedRoute,
    private commonSetting: CommonSetting,
    public service: ParticipationDataService, private offlineSurvey: OfflineSurvey) {
      this.isOfflineEnable = offlineSurvey.isOfflineEnable;
      this.surveyTitle=offlineSurvey.surveyTitle;
      this.offlineID = offlineSurvey.OfflineURLID;
      this.corp_mailid = offlineSurvey.corp_mailid;
    }

  ngOnInit() {
    let k = '';
    this.isOfflineEnable=true;
    this.activatedRoute.queryParams.subscribe(async params => {
      k = params['k'];
    });
    //this.OfflineResponseData = this.storage.get('ResponseData_' + k) || [];
    let encryptedData = this.storage.get('ResponseData_' + k) || [];
    if(encryptedData.length > 0){
      encryptedData = EncryptionAndDecryption.DecryptionData('123456$#@$^@1ERF', encryptedData);
      this.OfflineResponseData = JSON.parse(encryptedData);
    }
  
    this.storage.set('Editresponse_' + k, [])

    this.incompleteResponse = this.OfflineResponseData.filter(e=> e.ResponseCommanData.ResponseStatus=="INCOMPLETE").length;
    this.completeResponse = this.OfflineResponseData.filter(e=> e.ResponseCommanData.ResponseStatus=="COMPLETE").length;

    if (this.completeResponse > 0 || this.incompleteResponse == 0) {
      this.OfflineResponseData = this.OfflineResponseData.filter(e => e.ResponseCommanData.ResponseStatus == "COMPLETE");
    }
    else {
      this.OfflineResponseData = this.OfflineResponseData.filter(e => e.ResponseCommanData.ResponseStatus == "INCOMPLETE");
    }
    this.blnShowGotiT = this.storage.get('GotIT_' + k) != undefined ? this.storage.get('GotIT_' + k) : true ;
    this.ResponseRecorded = this.storage.get('ResponseRecorded_' + k) != undefined ? this.storage.get('ResponseRecorded_' + k) : 0 ;
    this.ResponseCount = this.storage.get('ResponseCount_' + k) || 0;
    if (this.ResponseCount == 0) {
      this.storage.set('ResponseCount_' + k, 0)
    }

    if (this.commonSetting != undefined) {
      var body = document.body;
      this.isMobile = this.commonSetting.isMobileDevice;
      this.isTablet =this.commonSetting.isTablet;
      if(this.isTablet)
      {
          if(navigator.maxTouchPoints > 1  || navigator.userAgent.toLowerCase().indexOf('firefox') > -1 || navigator.userAgent.toLowerCase().indexOf('ipad') > -1)
          {
              this.isTablet  = true;
          }
          else
          {
            this.isTablet  = false;
          }
      }
      this.service.setMobile(this.isMobile);
      if (this.isMobile) {
        body.classList.add('mobile-wrapper');
        if (this.isPreview && $("#previewViewport", parent.document).length == 0) {

          body.classList.add('mobile-scroll');
        }
       else if(!this.isPreview && !this.commonSetting.isEmbedMobile)
       {
          var body = document.body;
          body.classList.add('mobile-scroll');
        }
      }
      else if(this.isTablet){
        body.classList.add('tablet-wrapper');
        if ($("#previewViewport", parent.document).length == 0) {
          var body = document.body;
          body.classList.add('mobile-scroll');
        }
        else if(navigator.maxTouchPoints > 1)
        {
          var body = document.body;
          body.classList.add('mobile-scroll');
        }
      }
      this.CheckOfflineUrl();
      // this.IsMobileDevice();
    }

  }

  ngAfterViewInit() {
    // this.incompleteResponse = this.OfflineResponseData.filter(e => e.ResponseCommanData.ResponseStatus == "INCOMPLETE").length;
    // this.completeResponse = this.OfflineResponseData.filter(e => e.ResponseCommanData.ResponseStatus == "COMPLETE").length;

    if (this.completeResponse > 0 || this.incompleteResponse == 0) {
      $('.Incompleted').removeClass('active');
      $('.Completed').addClass('active');

    }
    else {
      $('.Completed').removeClass('active');
      $('.Incompleted').addClass('active');
    }
    if (this.isMobile) {
      setTimeout(() => {
        $('.r-numbers-cont').css('margin-top', $('.r-header').outerHeight() + 20 + 'px');
        if (this.ResponseCount == 0 && this.completeResponse + this.incompleteResponse == 0) {
          $('.r-tabs-cont').css('margin-top', $('.r-header').outerHeight() + 20 + 'px');
        } else {
        $('.r-tabs-cont').css('margin-top', '30px');
      }
    }, 100);
    }
  }

  ngAfterViewChecked(){
    setTimeout(() => {
      $('body').getNiceScroll().resize();
    }, 400);
  }
  
sendEmail()
{
   window.location.href= "mailto:"+ this.corp_mailid;
}

  Startsurvey() {
    // if (!navigator.onLine) {
      // this.GetData.emit();
      // this.Startsurvey1.emit();
      //let path = 'Survey1.aspx?' + this.GetUrlData(false);
      // let path = 'Offline.aspx?' + this.GetUrlData(false);
      //this.router.navigateByUrl(path);
    // }

    //response limit handle
    if (this.OfflineResponseData.length < 100) {
      let path = 'survey1.aspx?' + this.GetUrlData(false);
      this.router.navigateByUrl(path);
    } else {
      alert('Response Limit reached please upload pending responses and try again');
      let path = 'offline.aspx?' + this.GetUrlData(false);
      this.router.navigateByUrl(path);
    }
  }

  CheckOfflineUrl():boolean
  {
    let off_url = 'SurveyData/GetOfflineModeData?offlineID=' + this.offlineID;
    this.service.GetOfflineModeData(off_url).subscribe(async (data) => {
        this.isOfflineEnable = await data;
        if(this.isOfflineEnable == false)
        {
          return false;
        }
    }, error => {

    });
    return true;
  }

  CancelUpload() {
    this.isCancelUpload = true;
    $('.loading-wrapper').hide();
  }

  RetryResponses() {
    this.isSomthingWrong = false;
    this.UploadResponses();
  }

  CloseSomthingWrong() {
    this.isSomthingWrong = false;
    $('.loading-wrapper').hide();
  }

  UploadResponses(isResursiveCall: boolean = false) {
    if (navigator.onLine) {
      if (this.isOfflineEnable) {

        let k = '';
        var self = this;
        $(".loading-wrapper").css('display', '');
        this.activatedRoute.queryParams.subscribe(async params => {
          k = params['k'];
        });

        let strTick = "&Tick=" + this.commonSetting.strTick;
        let SkipLogicHiddenQIdsAll: string = null;
       // this.OfflineResponseData = this.storage.get('ResponseData_' + k) || [];
       
        let encryptedData = this.storage.get('ResponseData_' + k) || [];

        if (encryptedData.length > 0) {
          encryptedData = EncryptionAndDecryption.DecryptionData('123456$#@$^@1ERF', encryptedData);
          this.OfflineResponseData = JSON.parse(encryptedData);
        }

        if (!isResursiveCall) {
          this.prendingResponse = this.OfflineResponseData.length;
          this.processCount = 1;
          this.isCancelUpload = false;
        }

        if (this.OfflineResponseData.length > 0) {
          let url = 'SurveyData/OfflineResponseData?k=' + k + '&lang=0&Dir=NXT' + '' +
            "&PageNo=999" + strTick + "&intelMatrix=" + SkipLogicHiddenQIdsAll;

          // this.isCancelUpload = false;

          //this.OfflineResponseData.forEach(e => {
          if (!this.isSomthingWrong && !this.isCancelUpload) {
            let pagenumber = 1;
            let arrSavedPageList = this.OfflineResponseData[0].ResponseCommanData.SavedPageList.split(',');
            if (arrSavedPageList[arrSavedPageList.length - 1] != "") {
              pagenumber = arrSavedPageList[arrSavedPageList.length - 1];
            }
            if (this.OfflineResponseData[0].ResponseCommanData.ResponseStatus == "INCOMPLETE") {
              url = 'SurveyData/OfflineResponseData?k=' + k + '&lang=' + this.OfflineResponseData[0].ResponseCommanData.ResponseLangID + '&Dir=SAV' + '' +
                "&PageNo=" + pagenumber + strTick + "&intelMatrix=" + SkipLogicHiddenQIdsAll;
            } else {
              url = 'SurveyData/OfflineResponseData?k=' + k + '&lang=' + this.OfflineResponseData[0].ResponseCommanData.ResponseLangID + '&Dir=NXT' + '' +
                "&PageNo=" + pagenumber + strTick + "&intelMatrix=" + SkipLogicHiddenQIdsAll;
            }

            this.surveySpecificData = new SurveySpecificData();
            this.service.postDataUsingPromise(url, JSON.stringify(
              EncryptionAndDecryption.EncryptionData("123456$#@$^@1ERF", JSON.stringify(this.OfflineResponseData[0])))).then(async (data) => {

                //this.surveySpecificData.Participation_Messages = await data;
                var arrData = EncryptionAndDecryption.DecryptionData("123456$#@$^@1ERF", await data);
                this.surveySpecificData.Participation_Messages = JSON.parse(arrData);

                if (this.surveySpecificData.Participation_Messages != undefined) {
                  if (this.surveySpecificData.Participation_Messages.OfflineMessage == "succeces") {
                    this.ResponseRecorded = (this.ResponseRecorded + 1)
                    this.storage.set('ResponseRecorded_' + k, this.ResponseRecorded);

                    if (this.prendingResponse != 1) {
                      this.processCount = this.processCount + 1;
                    }

                    let val = ((this.processCount / this.prendingResponse) * 100)
                    if (val < 1) {
                      this.UploadPerc = 1;
                    }
                    else {
                      this.UploadPerc = Math.floor(val);
                    }                                   

                    let ind = this.OfflineResponseData.indexOf(this.OfflineResponseData[0]);
                    this.OfflineResponseData.splice(ind, 1);
                    this.incompleteResponse = this.OfflineResponseData.filter(a => a.ResponseCommanData.ResponseStatus == "INCOMPLETE").length;
                    this.completeResponse = this.OfflineResponseData.filter(a => a.ResponseCommanData.ResponseStatus == "COMPLETE").length;
                    //this.storage.set('ResponseData_' + k, this.OfflineResponseData);
                    this.storage.set('ResponseData_' + k, EncryptionAndDecryption.EncryptionData("123456$#@$^@1ERF", JSON.stringify(this.OfflineResponseData)));

                    $('.loading-filler').css('width', this.UploadPerc + '%')

                    if (this.UploadPerc == 100) {
                      setTimeout(() => {
                        $(".loading-wrapper").css('display', 'none');
                        this.showAlert($('.Plat_Alert'));
                      }, 500);
                    }
                  }

                  if (this.OfflineResponseData.length > 0) {
                    this.UploadResponses(true);
                  }
                }
              }, error => {
                this.isSomthingWrong = true;
              });
          } else {
            setTimeout(() => {
              $(".loading-wrapper").css('display', 'none');
            }, 100);
          }
          //});
        }
      }
    } else {
      alert('No Internet');
      setTimeout(() => {
        $(".loading-wrapper").css('display', 'none');
      }, 100);
    }
  }

  // UploadResponses() {
  //   if (navigator.onLine) {
  //     if (this.isOfflineEnable) {
  //       let k = '';
  //       var self = this;
  //       $(".loading-wrapper").css('display', '');
  //       this.activatedRoute.queryParams.subscribe(async params => {
  //         k = params['k'];
  //       });
  //       let strTick = "&Tick=" + this.commonSetting.strTick;
  //       let SkipLogicHiddenQIdsAll: string = null;
  //       this.OfflineResponseData = this.storage.get('ResponseData_' + k) || [];
  //       this.prendingResponse = this.OfflineResponseData.length;
  //       this.processCount = 1;
  //       if (this.OfflineResponseData.length > 0) {
  //         let url = 'SurveyData/OfflineResponseData?k=' + k + '&lang=0&Dir=NXT' + '' +
  //           "&PageNo=999" + strTick + "&intelMatrix=" + SkipLogicHiddenQIdsAll;

  //         this.isCancelUpload = false;

  //         this.OfflineResponseData.forEach(e => {
  //           if (!this.isSomthingWrong && !this.isCancelUpload) {
  //             let pagenumber = 1;
  //             let arrSavedPageList = e.ResponseCommanData.SavedPageList.split(',');
  //             if (arrSavedPageList[arrSavedPageList.length - 1] != "") {
  //               pagenumber = arrSavedPageList[arrSavedPageList.length - 1];
  //             }
  //             if (e.ResponseCommanData.ResponseStatus == "INCOMPLETE") {
  //               url = 'SurveyData/OfflineResponseData?k=' + k + '&lang=' + e.ResponseCommanData.ResponseLangID + '&Dir=SAV' + '' +
  //                 "&PageNo=" + pagenumber + strTick + "&intelMatrix=" + SkipLogicHiddenQIdsAll;
  //             } else {
  //               url = 'SurveyData/OfflineResponseData?k=' + k + '&lang=' + e.ResponseCommanData.ResponseLangID + '&Dir=NXT' + '' +
  //                 "&PageNo=" + pagenumber + strTick + "&intelMatrix=" + SkipLogicHiddenQIdsAll;
  //             }

  //             this.surveySpecificData = new SurveySpecificData();
  //             this.service.postDataUsingPromise(url, JSON.stringify(
  //               e)).then(async (data) => {

  //                 this.surveySpecificData.Participation_Messages = await data;

  //                 if (this.surveySpecificData.Participation_Messages != undefined) {
  //                   if (this.surveySpecificData.Participation_Messages.OfflineMessage == "succeces") {
  //                     this.ResponseRecorded = (this.ResponseRecorded + 1)
  //                     this.storage.set('ResponseRecorded_' + k, this.ResponseRecorded);

  //                     if (this.prendingResponse != 1) {
  //                       this.processCount = this.processCount + 1;
  //                     }

  //                     let val = ((this.processCount / this.prendingResponse) * 100)
  //                     if (val < 1) {
  //                       this.UploadPerc = 1;
  //                     }
  //                     else {
  //                       this.UploadPerc = Math.floor(val);
  //                     }
  //                     $('.loading-filler').css('width', this.UploadPerc + '%')
  //                     if (this.UploadPerc == 100) {
  //                       setTimeout(() => {
  //                         $(".loading-wrapper").css('display', 'none');
  //                         this.showAlert($('.Plat_Alert'));
  //                       }, 100);

  //                     }
  //                     // if (e.ResponseCommanData.ResponseStatus == "INCOMPLETE") {
  //                     //   this.incompleteResponse = (this.incompleteResponse - 1);
  //                     // }
  //                     // else {
  //                     //   this.completeResponse = (this.completeResponse - 1);
  //                     // }
                      
  //                     let ind = this.OfflineResponseData.indexOf(e);
  //                     this.OfflineResponseData.splice(ind, 1);
  //                     this.incompleteResponse = this.OfflineResponseData.filter(a=> a.ResponseCommanData.ResponseStatus=="INCOMPLETE").length;
  //                     this.completeResponse = this.OfflineResponseData.filter(a=> a.ResponseCommanData.ResponseStatus=="COMPLETE").length;
  //                     this.storage.set('ResponseData_' + k, this.OfflineResponseData);
  //                   }
  //                 }
  //                 // this.surveySpecificData.Participation_Messages = await data;
  //                 // if (this.surveySpecificData.Participation_Messages.isErrorRedirect) {
  //                 // }
  //                 // else {

  //                 // }
  //               }, error => {
  //                 this.isSomthingWrong = true;
  //               });
  //           }
  //         });
  //       }
  //     }
  //   } else {
  //     alert('No Internet');
  //     setTimeout(() => {
  //       $(".loading-wrapper").css('display', 'none');
  //     }, 100);
  //   }
  // }

  showAlert(obj) {
    obj.addClass('active');
  }

  Edit(response: ParticipationResponseData) {
    let k = '';
    let lang1='';
    this.activatedRoute.queryParams.subscribe(async params => {
      k = params['k'];
      lang1= response.ResponseCommanData.ResponseLangID.toString();// params["lang"];
    });   
    //this.SurveyData = this.storage.get('SurveyData_' + k+'_'+ response.ResponseCommanData.ResponseLangID) || [];
    var data = this.storage.get('SurveyData_' + k+'_'+ response.ResponseCommanData.ResponseLangID)  || [];
    var arrData = EncryptionAndDecryption.DecryptionData("123456$#@$^@1ERF", data);
    this.SurveyData = JSON.parse(arrData);
    this.SurveyData.SurveySpecificData.ParticipationResponseData = response;
    this.SurveyData.SurveyData.ResponseInfo.ResponseUID = response.ResponseCommanData.ResponseUID;
    // this.SurveyData.
    data =  EncryptionAndDecryption.EncryptionData("123456$#@$^@1ERF", JSON.stringify(this.SurveyData))
    this.storage.set('SurveyData1_' + k+'_'+lang1, data);
   // this.storage.set('Editresponse_' + k, response)
    this.storage.set('Editresponse_' + k,  EncryptionAndDecryption.EncryptionData("123456$#@$^@1ERF", JSON.stringify(response)));
    // this.SurveyResponseUpdate.emit();
    // this.GetData.emit();
    // this.Startsurvey1.emit();
    let path = 'survey1.aspx?k=' + k+'&lang='+lang1;//this.GetUrlData(false);
    // let path = 'Offline.aspx?' + this.GetUrlData(false);
    this.router.navigateByUrl(path);
  }
  Remove(response: ParticipationResponseData) {
    let k = '';
    let OfflineResponseData1;
    this.activatedRoute.queryParams.subscribe(async params => {
      k = params['k'];
    });
    //OfflineResponseData1=this.storage.get('ResponseData_' + k);
    let encryptedData = this.storage.get('ResponseData_' + k);
    encryptedData = EncryptionAndDecryption.DecryptionData('123456$#@$^@1ERF', encryptedData);
    OfflineResponseData1 = JSON.parse(encryptedData);

    let ind = OfflineResponseData1.indexOf(OfflineResponseData1.find(e=>(e.ResponseCommanData.ResponseUID  ==response.ResponseCommanData.ResponseUID )));
    let index= this.OfflineResponseData.indexOf(response);
    OfflineResponseData1.splice(ind, 1);
    this.OfflineResponseData.splice(index, 1);
    //this.storage.set('ResponseData_' + k, OfflineResponseData1);
    this.storage.set('ResponseData_' + k, EncryptionAndDecryption.EncryptionData("123456$#@$^@1ERF", JSON.stringify(OfflineResponseData1)));

    this.storage.set('ResponseCount_' + k, (this.storage.get('ResponseCount_' + k) || 0)-1);
    this.ResponseCount = this.storage.get('ResponseCount_' + k) || 0;

    this.incompleteResponse = OfflineResponseData1.filter(e=> e.ResponseCommanData.ResponseStatus=="INCOMPLETE").length;
    this.completeResponse = OfflineResponseData1.filter(e=> e.ResponseCommanData.ResponseStatus=="COMPLETE").length;

    if (this.isMobile) {
      $('.r-numbers-cont').css('margin-top', $('.r-header').outerHeight()+20 + 'px');
      if (this.ResponseCount == 0 && this.completeResponse + this.incompleteResponse == 0) {
        $('.r-tabs-cont').css('margin-top', $('.r-header').outerHeight()+20 + 'px');
      } else {
        $('.r-tabs-cont').css('margin-top', '30px');
      }
    }

  }
  GetUrlData(isLoading: boolean): any {
    this.activatedRoute.queryParams.subscribe(async params => {
      let k = params['k'];
      let Uid = ""
      let Dir = ""
      let lang = (params['lang'] == "" || params['lang'] == undefined) ? "0" : params['lang'];
      let goBackQuota = (params['isGoBackQuota'] == "" || params['isGoBackQuota'] == undefined) ? "" : "&isGoBackQuota=true";
      let isEmbedMobile = (params['isEmbedMobile'] == "" || params['isEmbedMobile'] == undefined) ? "" : "&isEmbedMobile=1"
      let isPartial = (params['isPartial'] == "" || params['isPartial'] == undefined) ? "" : "&isPartial=True"

      if (lang == undefined) {
        lang = (params['lang'] == "" || params['lang'] == undefined) ? "0" : params['lang'];
      }
      lang= this.offlineSurvey.primaryLang;

      let status = (params['status'] != undefined || params['status'] != null || params['Status'] != undefined || params['Status'] != null ? '&status=preview' : '');

      if (status == '&status=preview') {
        this.isPreview = true;
        let isThankYou = (params['isThankYou'] == "" || params['isThankYou'] == undefined) ? "" : "&isThankYou=" + params['isThankYou']
        let type = (params['type'] == "" || params['type'] == undefined) ? "" : "&type=" + params['type']
        let msgId = (params['msgId'] == "" || params['msgId'] == undefined) ? "" : "&msgId=" + params['msgId']
        status = status + isThankYou + type + msgId;
        // if ($("#hdnCurrentLang", parent.document).val() != -1 && $("#hdnCurrentLang", parent.document).val()) {
        //   lang = $("#hdnCurrentLang", parent.document).val();
        // }
      }

      if (!isLoading) {
        //lang = this.selectedLang != undefined || this.selectedLang != null ? (this.selectedLang != this.surveyData.SurveySettings.primary_lang_id ? this.selectedLang : "0" ) : "0";
        //Dir = '&Dir=FST';
      }
      if (isLoading) {
        Uid = (params['Uid'] == "" || params['Uid'] == undefined) ? "" : '&responseUID=' + params['Uid'];
        Dir = (params['Dir'] == "" || params['Dir'] == undefined) ? "" : '&Dir=' + params['Dir'];
      }

      let data = params['data'];

      this.urlParam = 'k=' + k + '&lang=' + lang + Uid + status + Dir + goBackQuota + isEmbedMobile + isPartial;
      this.selectedLang = lang;
    });
    return this.urlParam;
  }
  GotIt(){
    let k = '';
    this.activatedRoute.queryParams.subscribe(async params => {
      k = params['k'];
    });
    this.storage.set('GotIT_' + k,false);
    this.blnShowGotiT = false;
    
      if (this.isMobile) {
        setTimeout(() => {
        $('.r-numbers-cont').css('margin-top', $('.r-header').outerHeight() + 20 + 'px');
        if (this.ResponseCount == 0 && this.completeResponse + this.incompleteResponse == 0) {
          $('.r-tabs-cont').css('margin-top', $('.r-header').outerHeight() + 20 + 'px');
        } else {
          $('.r-tabs-cont').css('margin-top', '30px');
        }
      }, 10);
      }
    

    setTimeout(() => {
      $('body').getNiceScroll().resize();
    }, 250);
  }

  switchTabs(status : string ) {
    let k = '';
    this.activatedRoute.queryParams.subscribe(async params => {
      k = params['k'];
    });
    //this.OfflineResponseData = this.storage.get('ResponseData_' + k) || [];
    let encryptedData = this.storage.get('ResponseData_' + k) || [];

    if (encryptedData.length > 0) {
      encryptedData = EncryptionAndDecryption.DecryptionData('123456$#@$^@1ERF', encryptedData);
      this.OfflineResponseData = JSON.parse(encryptedData);
    }

    if(status == 'Completed')
    {
        $('.Incompleted').removeClass('active');
        $('.Completed').addClass('active');

        this.OfflineResponseData = this.OfflineResponseData.filter(e=> e.ResponseCommanData.ResponseStatus=="COMPLETE");
    }
    else
    {
        $('.Completed').removeClass('active');
        $('.Incompleted').addClass('active');
        this.OfflineResponseData = this.OfflineResponseData.filter(e=> e.ResponseCommanData.ResponseStatus=="INCOMPLETE");
    }
}

  //   selectAllRows(obj) {
  //     if($(obj).prop('checked') == true) {
  //       $('.offline-cb').prop('checked', true);
  //   } else {
  //       $('.offline-cb').prop('checked', false);
  //   }
  //   this.checkForUpload();
  // }
  // checkForUpload() {
  //   if($("input.offline-cb:checkbox:checked").length > 0) {
  //       $('.ob-upload').closest('.ob-cont').removeClass('btn-disabled');
  //   } else {
  //       $('.ob-upload').closest('.ob-cont').addClass('btn-disabled');
  //   }
  // }
  // checkAllRows() {
  //   if($("input.offline-cb:checkbox:not(:checked)").length > 0) {
  //       $('.main-cb').prop('checked', false);
  //   } else {
  //       $('.main-cb').prop('checked', true);
  //   }
  //   this.checkForUpload();
  // }

  // ngAfterViewInit() {

  //   $(document).ready(function() {
  //     this.checkForUpload();
  // });
  // }
}
